/* eslint-disable import/prefer-default-export */
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { getServiceDetailsConfig } from "api/services/location";
import { GetServiceDetailsConfigResponseType } from "api/response";
import { locationQueryKeys } from "./locationQueryKeys";

export function useGetServiceDetailsConfig(
  location: string,
  options?: UseQueryOptions<GetServiceDetailsConfigResponseType, unknown>,
): UseQueryResult<GetServiceDetailsConfigResponseType> {
  const func = async (): Promise<GetServiceDetailsConfigResponseType> => {
    const response = await getServiceDetailsConfig(location);
    return response.data;
  };

  return useQuery<GetServiceDetailsConfigResponseType, unknown>({
    queryKey: locationQueryKeys.getServiceDetailsConfig(location),
    queryFn: func,
    enabled: !!location,
    ...options,
  });
}
